import React from 'react'
import Breadcrumb from './Breadcrumb';
import Footer from '../../components/footer/Footer';
import ContactArea from './ContactArea';
import Brand from '../../components/index/Brand'
import HeaderOne from '../../components/header/HeaderOne';

function Contact() {
  return (
	<>
	<HeaderOne/>
	<main>

	<Breadcrumb/>
	<ContactArea/>
	<Brand/>
	</main>
	<Footer/>
	</>
  )
}

export default Contact